import classNames from 'classnames';
import { forwardRef } from 'react';
import { useMediaQueryDeviceStateValue } from '@/shared/atoms/media-query-device';
import Image from '@/shared/components/shared/Image';
import { useTypograf } from '@/shared/hooks/use-typograf';
import { ImageShape } from '@/shared/lib/types';
import Responsive from '../Responsive';

type Props = React.HTMLAttributes<HTMLElement> & {
    person: {
        avatar?: ImageShape | null;
        name: string;
        job: string;
    };
    quote: string;
};

const Blockquote = forwardRef<HTMLQuoteElement, Props>(({ person, quote, ...props }, ref) => {
    const tpName = useTypograf(person.name || '');
    const tpQuote = useTypograf(quote);
    const tpJob = useTypograf(person.job || '');
    const device = useMediaQueryDeviceStateValue();
    const isMobile = device.includes('mobile');

    return (
        <blockquote {...props} ref={ref} className={classNames('blockquote', props.className)}>
            <div className="blockquote-content-top">
                {isMobile && person.avatar && (
                    <div className="reviews-slider-slide-inner-mobile">
                        <Responsive className="reviews-slider-img-wrapper-mobile">
                            <Image
                                className="reviews-slider-img"
                                src={person.avatar.src}
                                alt={person.avatar.alt || person.name || ''}
                                title={person.avatar.title}
                                width={person.avatar.width}
                                height={person.avatar.height}
                            />
                        </Responsive>
                    </div>
                )}
                <div className="blockquote-name-block-wrapper">
                    <div className="blockquote-name-block">
                        {tpName && <div className="blockquote-name text-m">{tpName}</div>}
                        {tpJob && <div className="blockquote-job text-xs">{tpJob}</div>}
                    </div>
                </div>
            </div>
            {tpQuote && (
                <div className="blockquote-content-bottom">
                    <p className="review-quote h3">“</p>
                    <div className="text-l" dangerouslySetInnerHTML={{ __html: tpQuote }}></div>
                </div>
            )}
        </blockquote>
    );
});

Blockquote.displayName = 'Blockquote';

export default Blockquote;
